import { Alert, AlertDescription, AlertIcon, AlertTitle, AspectRatio, Box, Button, Divider, FormControl, FormErrorMessage, Heading, HStack, Image, Input, InputGroup, SimpleGrid, Text } from "@chakra-ui/react";
import { FC, ReactElement, useEffect, useState } from "react";
import Number from "components/number-format";

interface CheckoutVoucherProps {
    order: any,
};

const PayProgram: FC<CheckoutVoucherProps> = ({ order }): ReactElement => {

    return (
        <Box px={{ base: 4, md: 8 }} py={8}>
            <Box mb={4}>
                <Heading fontSize={'2xl'} fontWeight={"extrabold"} lineHeight={"short"}>{order.program.fullName}</Heading>
                <Text mt={1} fontSize={'sm'}>{order.program.description}</Text>
            </Box>
            <AspectRatio maxW='600px' ratio={16 / 9} flex={"1 1 auto"}>
                <Box borderRadius={"md"}>
                    <Image src={order.program.posterUrl} objectFit={"cover"} />
                </Box>
            </AspectRatio>
            <Box mt={2}>
                <Text textDecoration={'line-through'} color={'red.700'} fontWeight={'bold'} fontSize={'sm'}>
                    <Number displayType={'text'} prefix={'Rp '} thousandSeparator={true} value={order.program.priceOriginal} />
                </Text>
                <Text fontWeight={'bold'}>
                    <Text fontWeight={'bold'}>
                        {
                            order.program.price === 0 ?
                                'GRATIS'
                                :
                                <Number displayType={'text'} prefix={'Rp '} thousandSeparator={true} value={order.program.price} />
                        }
                    </Text>
                </Text>
            </Box>

            <SimpleGrid columns={{ base: 2, md: 2 }} spacing={2} my={1} fontSize={'sm'}>
                <Text>Subtotal</Text>
                <Text align={'right'}>
                    <Number displayType={'text'} prefix={'Rp '} thousandSeparator={true} value={order.subTotal} />
                </Text>
            </SimpleGrid>

            {
                order.voucherCode &&
                <>
                    <Divider __css={{ borderColor: '#a4a4a4' }} />

                    <SimpleGrid columns={{ base: 2, md: 2 }} spacing={2} my={1} fontSize={'sm'}>
                        <Text>Discount</Text>
                        <Text align={'right'} fontWeight={'bold'} color={'red.600'}>
                            <Number displayType={'text'} prefix={'Rp '} thousandSeparator={true} value={(order.discount * -1).toFixed(0)} />
                        </Text>
                    </SimpleGrid>
                </>
            }

            <Divider __css={{ borderColor: '#a4a4a4' }} />

            <SimpleGrid columns={{ base: 2, md: 2 }} spacing={2} my={1} fontSize={'sm'}>
                <Text>Total</Text>
                <Text align={'right'} fontWeight={'bold'}>
                    <Number displayType={'text'} prefix={'Rp '} thousandSeparator={true} value={order.amount} />
                </Text>
            </SimpleGrid>
        </Box>
    );
};

export default PayProgram;